
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojaisalamercab() {



    const cardData =
    {
        keyword: 'Pune to Jaisalmer Cab ',
        heading: 'Platinum24 Cabs: Pune to Jaisalmer Cab',
        headingDescription: ' Platinum24 Cabs provides reliable Pune to Jaisalmer cab services, perfect for tourists, families, and adventure seekers planning a trip to Rajasthan’s Golden City. Whether you’re visiting the iconic Jaisalmer Fort, enjoying desert safaris at Sam Sand Dunes, or exploring havelis and temples, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey. With professional chauffeurs, punctual pickups, and transparent pricing, we make your long-distance travel stress-free. From one-way rides to round-trip packages, Platinum24 Cabs guarantees a smooth and memorable Pune to Jaisalmer travel experience.',

        top: 'Top Places to Visit in Jaisalmer with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Jaisalmer Fort",
    "description": "Jaisalmer Fort, also known as Sonar Quila or Golden Fort, is one of the few living forts in the world. Built in 1156 by Rawal Jaisal, it glows golden under the desert sun. Inside, narrow lanes house temples, shops, hotels, and havelis. Its massive gates, Raj Mahal, and Jain temples showcase Rajput grandeur. Evening lights make it even more enchanting. Jaisalmer Fort is the city’s crown jewel of heritage."
  },
  {
    "title": "Patwon Ki Haveli",
    "description": "Patwon Ki Haveli is a cluster of five havelis built in the early 19th century. Known for its intricate stone carvings and grand facades, it once belonged to a wealthy merchant family. The haveli’s ornate balconies and murals are stunning. It houses a museum with artifacts from desert life. Photographers and history lovers find it fascinating. Patwon Ki Haveli is Jaisalmer’s architectural masterpiece."
  },
  {
    "title": "Sam Sand Dunes",
    "description": "Sam Sand Dunes, located 40 km from Jaisalmer, offer the ultimate Thar Desert experience. Camel safaris, jeep rides, and cultural performances make evenings lively. Tourists stay in desert camps under starry skies. Folk music, dance, and Rajasthani cuisine enhance the charm. Sunsets over the dunes are mesmerizing. Sam Sand Dunes are Jaisalmer’s desert adventure paradise."
  },
  {
    "title": "Salim Singh Ki Haveli",
    "description": "Salim Singh Ki Haveli, built in the 17th century, is known for its unique peacock-shaped roof. The haveli’s balconies and archways display stunning stone craftsmanship. It was once the residence of the prime minister of Jaisalmer. Legends of its grandeur and political power still intrigue visitors. Its blend of beauty and history makes it iconic. Salim Singh Haveli is Jaisalmer’s heritage gem."
  },
  {
    "title": "Nathmal Ki Haveli",
    "description": "Nathmal Ki Haveli, built by two architect brothers, is famous for its symmetrical yet unique design. Its exterior features intricate carvings of elephants, soldiers, and flowers. Inside, paintings with gold leaf add elegance. It served as a residence for the prime minister of Jaisalmer. The haveli reflects fine artistry and opulence. Nathmal Ki Haveli is Jaisalmer’s stunning blend of art and architecture."
  },
  {
    "title": "Gadisar Lake",
    "description": "Gadisar Lake, built in the 14th century by Maharawal Gadsi Singh, was once Jaisalmer’s water reservoir. Surrounded by temples, ghats, and shrines, it offers a peaceful setting. Boating and birdwatching are popular activities here. During winter, migratory birds flock to the lake. Sunrise and sunset views are particularly beautiful. Gadisar Lake is Jaisalmer’s serene water oasis."
  },
  {
    "title": "Kuldhara Village",
    "description": "Kuldhara is an abandoned village about 20 km from Jaisalmer, known for its eerie legends. It was once inhabited by the Paliwal Brahmins but mysteriously deserted overnight in the 19th century. Ruins of houses, temples, and streets remain intact. Folklore claims it is haunted, adding to its mystique. Tourists explore it for history and thrill. Kuldhara is Jaisalmer’s haunted heritage village."
  },
  {
    "title": "Bada Bagh",
    "description": "Bada Bagh, meaning Big Garden, houses royal cenotaphs (chhatris) of the Bhatti dynasty rulers. The sandstone domes with intricate carvings look majestic against desert backdrops. Sunset here offers mesmerizing views of golden chhatris. It is also a popular photography spot. The site reflects Jaisalmer’s royal legacy. Bada Bagh is the city’s peaceful historic garden."
  },
  {
    "title": "Desert National Park",
    "description": "Desert National Park, near Jaisalmer, showcases the unique ecosystem of the Thar Desert. Spread across 3,000 sq km, it is home to the Great Indian Bustard, desert foxes, and migratory birds. Fossils dating back 180 million years are found here. Jeep safaris let visitors explore its landscapes. It is a paradise for nature lovers and bird watchers. Desert National Park is Jaisalmer’s natural heritage site."
  },
  {
    "title": "Tanot Mata Temple",
    "description": "Tanot Mata Temple, located near the Indo-Pak border, is a revered shrine of Goddess Tanot. During the 1965 and 1971 wars, bombs dropped here reportedly did not explode, making it a symbol of divine protection. The temple is managed by the Border Security Force. Pilgrims and tourists visit to seek blessings and witness its unique history. Tanot Mata Temple is Jaisalmer’s divine and patriotic site."
  }
],


                       "services": [
    {
      "name": "Pune to Jaisalmer Cab",
      "description": "Experience the majestic journey from Pune to the golden city of Jaisalmer with our reliable Pune to Jaisalmer Cab service. Whether you’re traveling for leisure, heritage tourism, or family vacations, our fleet of well-maintained vehicles ensures a smooth and comfortable ride across this long-distance route. Our professional drivers are experienced in highway driving and prioritize your safety and comfort at every mile. Enjoy the convenience of flexible pickup and drop-off locations, real-time vehicle tracking, and customer-centric support throughout your journey. We also offer personalized travel assistance to help you plan stops at iconic landmarks along the way, making your trip more memorable and hassle-free."
    },
    {
      "name": "Book Pune to Jaisalmer Taxi",
      "description": "Booking your taxi from Pune to Jaisalmer has never been easier with our seamless online reservation system. Choose from a variety of vehicles that suit your travel style and budget, including sedans, SUVs, and luxury cars. Get instant confirmation, transparent fare estimates, and flexible cancellation policies that put your mind at ease. Our customer support team is available 24/7 to help with any queries or special requests, ensuring a smooth booking experience. Whether you need a one-way ride or a round trip, our Pune to Jaisalmer taxi booking service is designed to accommodate your every need with utmost professionalism and convenience."
    },
    {
      "name": "Pune to Jaisalmer Car Rental",
      "description": "Enjoy complete freedom on your journey with our Pune to Jaisalmer Car Rental service. Perfect for travelers who want flexibility and control, our rental options include self-drive and chauffeur-driven vehicles equipped with modern amenities for comfort and safety. Select from a wide range of cars, including compact, premium, and SUVs, to match your group size and preferences. Our cars undergo regular maintenance and sanitation to ensure a hygienic and reliable ride. Benefit from competitive pricing, easy online booking, and customizable rental durations, whether it’s a quick weekend trip or an extended stay in the desert city."
    },
    {
      "name": "Pune to Jaisalmer Outstation Cab",
      "description": "Travel long distances effortlessly with our Pune to Jaisalmer Outstation Cab service, tailored specifically for intercity journeys requiring extra comfort and convenience. Our drivers are skilled in managing highway routes and are trained to prioritize passenger safety and satisfaction. With ample luggage space, air-conditioned cabins, and smooth driving, your ride will be comfortable throughout the trip. We also provide optional stopovers and sightseeing detours along the way, allowing you to explore attractions without compromising your schedule. Enjoy clear fare structures, timely pickups, and flexible payment options for a stress-free travel experience."
    },
    {
      "name": "Cab from Pune to Jaisalmer",
      "description": "Our Cab service from Pune to Jaisalmer offers a hassle-free and reliable travel solution for visitors heading to this historic desert city. Equipped with GPS tracking, clean interiors, and courteous drivers, our cabs provide a safe and enjoyable environment for your journey. Whether traveling solo, with family, or in groups, we have vehicle options to accommodate all needs. Benefit from easy booking methods, fixed pricing with no hidden costs, and round-the-clock customer support to ensure your trip is smooth from start to finish."
    },
    {
      "name": "Pune to Jaisalmer One Way Taxi",
      "description": "Take advantage of our Pune to Jaisalmer One Way Taxi service for a cost-effective and flexible travel option. Ideal for travelers who require transportation in a single direction without the hassle of arranging return trips. Our one-way taxis are well-maintained, driven by professional chauffeurs, and offer all the amenities necessary for a comfortable long-distance ride. Transparent pricing and reliable service mean you can focus on enjoying your trip while we handle the logistics."
    },
    {
      "name": "Jaisalmer to Pune Cab",
      "description": "Plan your return trip with confidence using our Jaisalmer to Pune Cab service, offering safe and comfortable rides back to Pune. Whether you’re concluding a vacation, business trip, or family visit, our fleet is prepared to provide punctual pickups and smooth rides. Our drivers are familiar with the return routes and traffic conditions, ensuring efficient travel. Booking options include online reservations, phone support, and customizable schedules to suit your convenience."
    },
    {
      "name": "Pune to Jaisalmer Taxi Fare",
      "description": "Get upfront and transparent pricing with our Pune to Jaisalmer Taxi Fare details, helping you plan your budget without surprises. Our fare structure factors in distance, vehicle type, tolls, and any additional services, offering competitive rates that provide great value. Discounts on early bookings, group travel, and seasonal offers make our taxi fares even more affordable. For personalized fare quotes or package deals, reach out to our customer service team anytime."
    },
    {
      "name": "Affordable Pune to Jaisalmer Cab Service",
      "description": "Travel smart and save with our Affordable Pune to Jaisalmer Cab Service, designed to offer budget-friendly rides without compromising on comfort or safety. Perfect for students, families, and solo travelers, our fleet includes fuel-efficient and well-maintained vehicles that deliver excellent mileage and reliability. Enjoy transparent pricing, frequent promotions, and flexible booking options tailored to meet diverse travel needs. Whether it’s a quick trip or a long journey, our affordable cab service ensures you get the best value for your money while experiencing quality transportation."
    }
  ],
  "tableData": [
    ["Pune to Jaisalmer Cab", "Book Pune to Jaisalmer Taxi"],
    ["Pune to Jaisalmer Car Rental", "Pune to Jaisalmer Outstation Cab"],
    ["Cab from Pune to Jaisalmer", "Pune to Jaisalmer One Way Taxi"],
    ["Jaisalmer to Pune Cab", "Pune to Jaisalmer Taxi Fare"],
    ["Affordable Pune to Jaisalmer Cab Service", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Jaisalmer Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers comfortable and trustworthy cab services from Pune to Jaisalmer, ensuring a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles to Suit Your Needs",
    "WhyChoosedescription": "Choose from sedans, SUVs, hatchbacks, and tempo travellers suitable for your Pune to Jaisalmer travel."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Jaisalmer route, ensuring timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares including tolls, fuel, and driver allowances for a hassle-free cab experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Jaisalmer cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans customized for your Pune to Jaisalmer journey."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Jaisalmer cab quickly and securely via our website or app with immediate confirmation."
  }
]


























    }

    
const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Jaisalmer cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Jaisalmer with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Jaisalmer?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Jaisalmer travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Jaisalmer?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Jaisalmer travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Jaisalmer long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Jaisalmer route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Jaisalmer?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points according to your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Jaisalmer cabs?',
        answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Jaisalmer cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Jaisalmer cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Jaisalmer cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for smooth payment transactions.',
    },
    {
        question: 'Are customizable packages available for Pune to Jaisalmer cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rakesh Sharma',
        feedback: 'My Pune to Jaisalmer trip was fantastic with Platinum24 Cabs. Comfortable ride and punctual driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Singh',
        feedback: 'Highly recommend Platinum24 Cabs for Pune to Jaisalmer travel. Excellent service and clean cars.',
        rating: 5,
    },
];















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToJaisalmerCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jaisalmer Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-jaisalmer-cab.jpg",
  "description": "Book Pune to Jaisalmer cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable, safe, and available 24/7 for your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-jaisalmer-cab-service"
  }
};





    return (
        <div>



<Helmet>
  <title>Pune to Jaisalmer Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Jaisalmer cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable, safe, and available 24/7 for your travel needs."
  />
  <meta
    name="keywords"
    content="Pune to Jaisalmer Cab, Book Pune to Jaisalmer Taxi, Pune to Jaisalmer Car Rental, Pune to Jaisalmer Outstation Cab, Cab from Pune to Jaisalmer, Pune to Jaisalmer One Way Taxi, Jaisalmer to Pune Cab, Pune to Jaisalmer Taxi Fare, Affordable Pune to Jaisalmer Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJaisalmerCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/111.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojaisalamercab;